<template>
  <section>
    <div class="row my-3 p-3">
      <div class="col-lg-3 col-md-6 col-6 text-center p-3">
        <div
          class="icon-section"
          @click="goto('About')">
          <img
            :src="aboutIcon"
            class="img-fluid header-icon">
          <h4 class="mt-4 icon-title">ABOUT US</h4>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-6 text-center p-3">
        <div
          class="icon-section"
          @click="goto('Advantage')">
          <img
            :src="handShakeIcon"
            class="img-fluid header-icon">
          <h4 class="mt-4 icon-title">PARTNER BENEFITS</h4>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-6 text-center p-3">
        <div
          class="icon-section"
          @click="goto('Brands')">
          <img
            :src="brandsIcon"
            class="img-fluid header-icon">
          <h4 class="mt-4 icon-title">DEPENDABLE BRANDS</h4>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-6 text-center p-3">
        <div
          class="icon-section"
          @click="goto('Contact')">
          <img
            :src="contactIcon"
            class="img-fluid header-icon">
          <h4 class="mt-4 icon-title">CONTACT US</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data(){
      return{
        aboutIcon: require('../../../../../assets/images/ejw/home/eStore_Icon_OurHistory.png'),
        handShakeIcon: require('../../../../../assets/images/ejw/home/eStore_Icon_PartnerBenefits.png'),
        brandsIcon: require('../../../../../assets/images/ejw/home/eStore_Icon_Brands.png'),
        contactIcon: require('../../../../../assets/images/ejw/home/eStore_Icon_ContactUs.png'),
      }
    },
    methods:{
      goto(routeName){
        this.$router.push({name: routeName})
      }
    }
  }
</script>

<style scoped>
  .header-icon{
    height:auto;
    max-height:200px;
    width: 100%;
    max-width:200px;
  }
  .icon-text{
    min-height:120px;
  }
  .icon-title{
    min-height: 25px;
  }
  .icon-section:hover{
    transition: .20s ease-in-out;
    text-shadow: 5px 5px 10px lightgray;
    transform: scale(1.05) translatey(-5%);
    border-radius:20px;
    cursor: pointer;
    color: var(--bs-theme-red);
  }
</style>